import type { Project } from '@/lib/data';
import type { Locale } from './config';

/**
 * Returns `project` with its translatable fields swapped for the given
 * locale's overrides (`project.translations[locale]`), falling back
 * per-field to the original English value when a translation is missing or
 * the locale is English.
 */
export function localizeProject(project: Project, locale: Locale): Project {
  if (locale === 'en') return project;

  const override = project.translations?.[locale];
  if (!override) return project;

  return {
    ...project,
    title: override.title ?? project.title,
    category: override.category ?? project.category,
    description: override.description ?? project.description,
  };
}
